import React from 'react';
import { ApiCategoryPage } from '../components/ApiCategoryPage';
import { API_ENDPOINTS_GROUPED_SORTED } from '../data/endpoints';

export const GeneralApiPage: React.FC = () => {
  return (
    <ApiCategoryPage
      categoryName="general"
      categoryDisplayName="General"
      endpoints={API_ENDPOINTS_GROUPED_SORTED.general}
    />
  );
};